module.exports = __webpack_public_path__ + "static/img/brand-second-4.e2364f0a.png";